import React, { useState } from 'react';
import styles from '../../_css/Login.module.css';
import { notifyError, notifySuccess } from '../../utils/helper';
import { forgotPassword } from '../../requests';
import { Mail, ArrowLeft } from 'lucide-react';

const ForgotPassword = ({ onBack, initialEmail = '' }) => {
  const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo.png`;
  const [email, setEmail] = useState(initialEmail);
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      notifyError('Please enter a valid email');
      return;
    }

    setSubmitting(true);
    try {
      const response = await forgotPassword({ email });
      if (response?.status < 400) {
        setSent(true);
        notifySuccess(
          response?.data?.message ||
            'Password reset link has been sent to your email address'
        );
      } else {
        notifyError(response?.data?.message || 'Something went wrong');
      }
    } catch (error) {
      notifyError(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className={`app-background w-full min-h-screen h-full flex items-center justify-center overflow-y-auto ${styles.loginPage}`}
    >
      <div className="app-background-surface w-full max-w-md px-3 py-4 sm:px-4 sm:py-6 md:px-6 md:py-8">
        <div className={styles.authCard}>
          <form onSubmit={handleSubmit} className={styles.authForm}>
            <div className={styles.authHeader}>
              <div className={styles.authLogoWrap}>
                <img src={LOGO_SRC} alt="Company logo" className={styles.authLogo} />
              </div>
              <p className={styles.authSubtitle}>
                {sent ? 'Check your email' : 'Reset your password'}
              </p>
              <hr className={styles.authDivider} />
            </div>

            <button type="button" onClick={onBack} className={styles.authBackButton}>
              <ArrowLeft size={16} aria-hidden="true" />
              Back to login
            </button>

            {sent ? (
              <div className={styles.authPendingNote}>
                A password reset link has been sent to <strong>{email}</strong>.
                The link expires in 1 hour. Check your inbox and spam folder.
              </div>
            ) : (
              <>
                <p className={styles.authForgotHint}>
                  Enter the email address associated with your account and we&apos;ll
                  send you a link to reset your password.
                </p>

                <div>
                  <label htmlFor="forgot-email" className={styles.authLabel}>
                    Email Address
                  </label>
                  <div style={{ position: 'relative' }}>
                    <Mail
                      className={styles.authIcon}
                      style={{
                        position: 'absolute',
                        left: 14,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 18,
                        height: 18,
                        pointerEvents: 'none',
                      }}
                    />
                    <input
                      id="forgot-email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      className={`${styles.authInput} ${styles.authInputIconLeft}`}
                      required
                      autoComplete="email"
                    />
                  </div>
                </div>

                <button type="submit" className={styles.authSubmit} disabled={submitting}>
                  {submitting ? 'Sending...' : 'Send reset link'}
                </button>
              </>
            )}
          </form>
        </div>

        <p className={styles.authFooterNote}>
          Secure login powered by enterprise-grade encryption
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
